module.exports = __webpack_public_path__ + "img/Exhibition_Logo.b444d690.png";